module.exports = __webpack_public_path__ + "static/media/logout.e8338a84.svg";